import Ajv from 'ajv';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

import type { SearchParams } from '@/api/apiClient/search';

import { ContentType, SortOption } from '@/api/apiClient/search';

export const useSearchQueryString = () => {
  const route = useRoute();

  return computed<SearchParams>(() => {
    const stringQuery = route.query.q as string;

    let parsedQuery;
    try {
      parsedQuery = JSON.parse(stringQuery);
    } catch {
      return { text: '' };
    }

    if (!validateSearchParams(parsedQuery)) {
      return { text: '' };
    }
    return parsedQuery as SearchParams;
  });
};

const SEARCH_PARAMS_SCHEMA = {
  type: 'object',
  properties: {
    text: { type: 'string' },
    contentType: {
      type: 'array',
      items: {
        type: 'string',
        enum: Object.values(ContentType),
      },
      required: [],
      nullable: true,
    },
    includePending: { type: 'boolean', nullable: true },
    orgCreated: { type: 'boolean', nullable: true },
    orgReviewed: { type: 'boolean', nullable: true },
    thirdParty: { type: 'boolean', nullable: true },
    pendingOnly: { type: 'boolean', nullable: true },
    sort: {
      type: 'string',
      enum: Object.values(SortOption),
      nullable: true,
    },
  },
  required: ['text'],
};
const ajv = new Ajv();
const validateSearchParams = ajv.compile(SEARCH_PARAMS_SCHEMA);
